export default [
  {
    path: "/incubatorType",
    name: "incubatorType",
    component: () => import("@/views/Incubator/IncubatorType.vue"),
  },
  {
    path: "/incubators",
    name: "incubators",
    component: () => import("@/views/Incubator/incubators.vue"),
  },
  {
    path: "/patientCardIncubators",
    name: "patientCardIncubators",
    component: () => import("@/views/Incubator/patientCardIncubators.vue"),
  },
  {
    path: "/patient-incubators/:id",
    name: "PatientIncubatorShow",
    component: () => import("@/views/Incubator/PatientIncubatorShow.vue"),
  },
];
